import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["nameSpace", "label", "openButtonVariant", "axisDisplay", "hasScalesMinMax", "scaleMin", "scaleMax", "scaleDataMax", "scaleDataMin", "forceZeroBaseline", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import isEqual from 'lodash/isEqual';
import React, { useMemo, useState } from 'react';
import { isDashedBorder } from '@/components/Editor/Form/fields/common/Border/utils';
import { Label, Input, Checkbox } from '@/components/FormElements';
import RevealPill, { PillSwitch } from '@/components/Editor/Form/fields/RevealPill';
import ScaleMinMaxFields from '@/components/Editor/Form/fields/ScaleMinMaxFields';
import BorderFields, { BorderStyle } from '@/components/Editor/Form/fields/common/Border';
import { TemplateSection } from '@/components/Editor/Form/fields/Template';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import controlStyles from '@/components/FormElements/styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const AxisRevealPill = _ref => {
  let {
    nameSpace,
    label,
    openButtonVariant,
    axisDisplay = true,
    hasScalesMinMax,
    scaleMin,
    scaleMax,
    scaleDataMax,
    scaleDataMin,
    forceZeroBaseline,
    onChange
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const scaleId = `${nameSpace}-scale`;
  return /*#__PURE__*/_jsxs(RevealPill, {
    label: label,
    openButtonVariant: openButtonVariant,
    disableOpen: !axisDisplay,
    activeState: /*#__PURE__*/_jsx(PillSwitch, {
      checked: axisDisplay,
      onChange: checked => onChange({
        axisDisplay: checked
      })
    }),
    children: [/*#__PURE__*/_jsx(AxisFields, _objectSpread(_objectSpread({
      nameSpace: nameSpace
    }, props), {}, {
      onChange: onChange
    })), hasScalesMinMax ? /*#__PURE__*/_jsx(ScaleMinMaxFields, {
      scaleLabel: "Axis",
      nameSpace: scaleId,
      scaleMinKey: "scaleMin",
      scaleMaxKey: "scaleMax",
      scaleMin: scaleMin,
      scaleDataMin: scaleDataMin,
      scaleMax: scaleMax,
      scaleDataMax: scaleDataMax,
      forceZeroBaseline: forceZeroBaseline,
      onChange: onChange
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};

const AxisFields = _ref2 => {
  let {
    nameSpace,
    axisTitle,
    exampleValue,
    axisTemplate,
    defaultTemplate,
    onChange
  } = _ref2;
  const axisTitleId = `${nameSpace}-axis-heading`;
  const axisTemplateId = `${nameSpace}-axis-template`;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Label, {
      forInput: axisTitleId,
      text: "Title",
      className: parentStyles.formField,
      children: /*#__PURE__*/_jsx(Input, {
        id: axisTitleId,
        placeholder: "Year",
        defaultValue: axisTitle,
        onChange: evt => onChange({
          axisTitle: `${evt.target.value}`.trim() || null
        })
      })
    }), /*#__PURE__*/_jsx(TemplateSection, {
      id: axisTemplateId,
      label: "Axis Formatting",
      caption: "How axis labels will be presented",
      exampleValue: exampleValue,
      template: axisTemplate ?? defaultTemplate,
      onChange: value => onChange({
        axisTemplate: value
      })
    })]
  });
};

const AxesGridLinesRevealPill = _ref3 => {
  let {
    nameSpace,
    label = 'Grid Lines',
    axesGrid = {},
    defaults = {},
    colorPallet = [],
    openButtonVariant,
    onChange
  } = _ref3;
  const showHideXAxisGrid = `${nameSpace}-show-hide-x-axis-grid`;
  const showHideYAxisGrid = `${nameSpace}-show-hide-y-axis-grid`;
  const yAxisBorderFieldsId = `${nameSpace}-y-axis-border-fields`;
  const xAxisBorderFieldsId = `${nameSpace}-x-axis-border-fields`;
  const {
    0: updatedAt,
    1: setUpdatedAt
  } = useState(Date.now());

  const handleAxisReset = updates => {
    typeof onChange === 'function' && onChange(updates);
    setTimeout(() => setUpdatedAt(Date.now()));
  };

  const isModified = useMemo(() => {
    const axesGridKeys = Object.keys(axesGrid);
    return Object.entries(defaults).some(_ref4 => {
      let [key, value] = _ref4;

      // Do not consider the key if it is not in the defaults
      // or if the value is not set
      if (axesGridKeys.includes(key) && typeof axesGrid[key] !== 'undefined') {
        return !isEqual(axesGrid[key], value);
      }

      return false;
    });
  }, [defaults, axesGrid]);
  const xAxisGridVisible = axesGrid.xAxisGridVisible ?? defaults.xAxisGridVisible ?? true;
  const yAxisGridVisible = axesGrid.yAxisGridVisible ?? defaults.yAxisGridVisible ?? true;
  const xAxisGridBorderDash = axesGrid.xAxisGridBorderDash ?? defaults.xAxisGridBorderDash ?? [5, 5];
  const yAxisGridBorderDash = axesGrid.yAxisGridBorderDash ?? defaults.yAxisGridBorderDash ?? [5, 5];
  return /*#__PURE__*/_jsxs(RevealPill, {
    label: label,
    variant: isModified ? 'active' : '',
    openButtonVariant: openButtonVariant,
    disableOpen: !xAxisGridVisible && !yAxisGridVisible,
    activeState: /*#__PURE__*/_jsx(PillSwitch, {
      checked: xAxisGridVisible || yAxisGridVisible,
      onChange: checked => onChange({
        xAxisGridVisible: checked,
        yAxisGridVisible: checked
      })
    }),
    children: [/*#__PURE__*/_jsx(Checkbox, {
      id: showHideXAxisGrid,
      className: parentStyles.formField,
      checked: xAxisGridVisible,
      onChange: evt => onChange({
        xAxisGridVisible: evt.target.checked
      }),
      children: /*#__PURE__*/_jsx("span", {
        className: controlStyles.optionsInputHeading,
        children: "Show X Axis Grid"
      })
    }), xAxisGridVisible ? /*#__PURE__*/_jsx(BorderFields, {
      nameSpace: xAxisBorderFieldsId,
      width: axesGrid.xAxisGridBorderWidth,
      style: isDashedBorder(xAxisGridBorderDash) ? BorderStyle.Dashed : BorderStyle.Solid,
      color: axesGrid.xAxisGridColor ?? defaults.xAxisGridColor ?? '',
      colorPallet: colorPallet,
      enabledButtonStyles: [BorderStyle.Solid, BorderStyle.Dashed],
      textOverrides: {
        legend: 'Grid Lines',
        clearBorder: 'Reset to default',
        widthPlaceholder: `${defaults.xAxisGridBorderWidth ?? 1}`
      },
      onChangeColor: borderColor => onChange({
        xAxisGridColor: borderColor
      }),
      onChangeStyle: borderStyle => onChange({
        xAxisGridBorderDash: borderStyle === BorderStyle.Dashed ? [5, 5] : [0, 0]
      }),
      onChangeWidth: borderWidth => onChange({
        xAxisGridBorderWidth: borderWidth
      }),
      onDelete: () => handleAxisReset({
        xAxisGridVisible: null,
        xAxisGridColor: null,
        xAxisGridBorderDash: null,
        xAxisGridBorderWidth: null
      })
    }, `${xAxisBorderFieldsId}-${updatedAt}`) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(Checkbox, {
      id: showHideYAxisGrid,
      className: parentStyles.formField,
      checked: yAxisGridVisible,
      onChange: evt => onChange({
        yAxisGridVisible: evt.target.checked
      }),
      children: /*#__PURE__*/_jsx("span", {
        className: controlStyles.optionsInputHeading,
        children: "Show Y Axis Grid"
      })
    }), yAxisGridVisible ? /*#__PURE__*/_jsx(BorderFields, {
      nameSpace: yAxisBorderFieldsId,
      width: axesGrid.yAxisGridBorderWidth,
      style: isDashedBorder(yAxisGridBorderDash) ? BorderStyle.Dashed : undefined,
      color: axesGrid.yAxisGridColor ?? defaults.yAxisGridColor ?? '',
      colorPallet: colorPallet,
      enabledButtonStyles: [BorderStyle.Solid, BorderStyle.Dashed],
      textOverrides: {
        legend: 'Grid Lines',
        clearBorder: 'Reset to default',
        widthPlaceholder: `${defaults.yAxisGridBorderWidth ?? 1}`
      },
      onChangeColor: borderColor => onChange({
        yAxisGridColor: borderColor
      }),
      onChangeStyle: borderStyle => onChange({
        yAxisGridBorderDash: borderStyle === BorderStyle.Dashed ? [5, 5] : [0, 0]
      }),
      onChangeWidth: borderWidth => onChange({
        yAxisGridBorderWidth: borderWidth
      }),
      onDelete: () => handleAxisReset({
        yAxisGridVisible: null,
        yAxisGridColor: null,
        yAxisGridBorderDash: null,
        yAxisGridBorderWidth: null
      })
    }, `${yAxisBorderFieldsId}-${updatedAt}`) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};

export default AxisRevealPill;
export { AxisRevealPill, AxesGridLinesRevealPill, AxisFields };